<template>
    <link-dialog v-model="show"
                 dialog-class="link-slider-service"
                 noHeader
                 noFooter
                 height="100%"
                 width="100%"
                 noPadding
                 shadowColor="transparent"
                 transition="link-dialog-scale"
                 destroyOnHide
                 :zIndex="9999"
                 full>
        <div class="link-slider-service-content">
            <link-slider :page-index.snyc="pageIndex" :loop="false" :auto-play="false" :no-dot="false" ref="linkSlider" @dblclick.native="modalClose">
                <div v-for="(item,index) in filterPicData" :key="index" class="link-slider-service-center">
                    <img :style="{maxWidth}" v-if="!!item.img" :src="item.img">
                    <video v-else-if="!!item.video" :src="item.video" controls="controls" height="80%"></video>
                </div>
            </link-slider>
            <div class="link-slider-service-icon link-slider-service-icon-left" v-show="filterPicData.length !== 1"
                 @click="pagePrev">
                <link-icon icon="link-icon-left"/>
            </div>
            <div class="link-slider-service-icon link-slider-service-icon-right" v-show="filterPicData.length !== 1"
                 @click="pageNext">
                <link-icon icon="link-icon-right"/>
            </div>
            <div class="link-slider-service-icon link-slider-service-link-close" @click="modalClose">
                <link-icon icon="link-icon-close"/>
            </div>
            <div class="link-slider-cover">
                <div class="img-title" v-if="showTitle">当前参与人数: <span style="color: red;">{{countNum ? countNum : '0'}}</span> 人</div>
                <div class="img-info">{{picInfo}}</div>
            </div>
        </div>
    </link-dialog>
</template>

<script>

    export default {
        name: "link-slider-service",
        data() {
            const defaultOption = {
                picData: [],                                    // 附件数据
                picInfo: '',                                    // 附件信息数组
                picKey: null,                                   // 附件数据中资源地址所在的属性名
                pageIndex: 0,                                   // 初始展示附件的位置索引
                maxWidth: {default: '85%'},                     // 默认最大宽度
                showTitle: false,                               // 是否显示头标题
                countNum: null,                                 // 传入组件的数据 仅摇一摇使用
            }
            return {
                show: false,

                defaultOption,
                ...defaultOption,
            }
        },
        computed: {
            // 计算属性，判断接收的数据时对象还是数组
            filterPicData() {
                let data = Array.isArray(this.picData) ? this.picData : [this.picData];
                return data.map(item => {
                    let ret = {}
                    let path = !!this.picKey ? item[this.picKey] : item
                    if (path.indexOf('mp4') > -1 && !path.startsWith('data:')) ret.video = path
                    else {
                        ret.img = path
                    }
                    return ret
                })
            }
        },
        methods: {
            pick(option) {
                Object.assign(this, this.defaultOption, option)
                this.show = true
            },
            /**
             * 预览上一张图片
             * @createdby：WangYue
             * @date：2018/12/18
             */
            pagePrev() {
                this.$refs.linkSlider.gotoPrev();
            },
            /**
             * 预览下一张图片
             * @createdby：WangYue
             * @date：2018/12/18
             */
            pageNext() {
                this.$refs.linkSlider.gotoNext();
            },
            /**
             * 关闭预览
             * @createdby：WangYue
             * @date：2018/12/18
             */
            modalClose() {
                this.show = false;
            },
            /**
             *@createdBy 常九福
             *@date 2019/10/21
             *@methods: freshCount
             *@para: val 最新的标题内容
             *@description: 刷新头标题
             **/
            freshCount(val) {
                this.countNum = val;
            }
        }
    }
</script>

<style lang="scss">
    .link-slider-service {
        .link-dialog-content {
            background-color: transparent !important;
            position: relative;

            .link-slider-service-content {
                height: 100%;
                position: relative;
                background-color: rgba(0, 0, 0, 0.65);

                .link-slider-wrpper {
                    height: 100%;

                    .link-slider-group {
                        height: 100%;

                        .link-slider-service-center {
                            height: 100%;
                            display: flex;
                            justify-content: center;
                            align-items: center;

                            img {
                                max-width: 80%;
                                max-height: 80%;
                            }
                        }
                    }
                }

                .link-slider-cover {
					position: absolute;
					top: 0;
					bottom: 0;
					left: 0;
					right: 0;
					display: flex;
					justify-content: center;
					align-items: center;
					color: #fff;
					pointer-events: none;

                    & > div {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        pointer-events: auto;
                    }

                    .img-title {
						font-family: PingFangTC-Semibold;
						color: #fff;
						font-weight: bold;
						font-size: 30px!important;
						position: absolute;
						top: 4%;
						font-size: 1.5rem;
						line-height: 2rem;
					}

                    .img-info {
						font-family: PingFangTC-Semibold;
						color: white;
						position: absolute;
						bottom: 4%;
						font-size: 1.5rem;
						line-height: 2rem;
					;
                    }
                }
            }

            .link-slider-service-icon {
                font-size: 42px;
                color: rgba(255, 255, 255, 0.75);
                cursor: pointer;
                position: absolute;
            }

            .link-slider-service-icon-left {
                top: 50%;
                left: 24px;
            }

            .link-slider-service-icon-right {
                top: 50%;
                right: 24px;
            }

            .link-slider-service-link-close {
                font-size: 24px;
                top: 24px;
                right: 24px;
            }
        }
    }
</style>
